import React, { useEffect, useMemo, useState, useRef, useCallback } from "react";
import { Select } from "antd";
import apiCalls from "src/api/apiCalls";

const PhoneCodeDropdown = ({
  onChange,
  value,
  className,
  disabled,
  loading = false,
}) => {
  const [getPhoneCodeData,setGetPhoneCodeData]=useState([])
   const shouldLog = useRef(true);

  const handleChange = useCallback((newValue) => {
    const dialCode = getPhoneCodeData?.find((item) => item.name == newValue)?.dial_code;
    onChange?.(dialCode);
  }, [getPhoneCodeData, onChange]);

  useEffect(() => {
    if (shouldLog.current) {
      shouldLog.current = false;
      getPhoneCodes();
    }
  }, [])

  const getPhoneCodes = async () => {
    try {
        const responce = await apiCalls.getPhoneCodesLookupLu()
        if (responce?.ok) {
            setGetPhoneCodeData(responce?.data?.CountryCode)
        }
        else {
            apiCalls.isErrorDispaly(responce?.data?.error?.message)
            window.scroll(0,0)
        }
    } catch (error) {
        setLoader(false)
        apiCalls.isErrorDispaly(error?.message)
        window.scroll(0,0)
    }
}
const list = getPhoneCodeData?.map((country) => {
  return {
    label: `(${country.dial_code}) ${country.name}`,
    value: `${country.name}`,
  };
});
  const parsedValue = useMemo(() => {
    return getPhoneCodeData?.find((item) => item.name == value)?.dial_code
  }, [value]
  );
  return (
    <Select
      className={className}
      showSearch
      allowClear
      dropdownStyle={{ width: "200px" }}
      placeholder="Phone Code"
      optionFilterProp="label"
      onChange={handleChange}
      value={parsedValue || value}
      options={list}
      loading={loading}
      disabled={disabled}
    />
  );
};

export default PhoneCodeDropdown;
